<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    :editIcon="editIcon"
    :readOnly="readOnly"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :isTextButton="isTextButton"
    :textButton="textButton"
  >
    <template slot="editForm">
      <Form
        ref="form"
        v-if="!loading"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :partialReadOnly="partialReadOnly"
        @installment-update="loadServerEntry(entry.id)"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null,
      partialReadOnly: false
    };
  },
  props: {
    entry: Object,
    // editTitle: {
    //   type: String,
    //   default: "Edição de Serviço de Patrimônio"
    // },
    // readTitle: {
    //   type: String,
    //   default: "Visualização de Serviço de Patrimônio"
    // },
    editIcon: {
      type: String,
      default: "mdi-pencil"
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    // partialReadOnly: {
    //   type: Boolean,
    //   default: false
    // },
    isTextButton: {
      type: Boolean,
      default: false
    },
    textButton: {
      type: String,
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit,
    BasePrint: BasePrint
  },
  created() {
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_SERVICE_PROVISION,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.serviceProvision;
          if (this.editableEntry.cashOutflowAttributes == null) {
            this.editableEntry.cashOutflowAttributes = response.data.accountContext.cashOutflow;
          }
          this.extraData = response.data;
          this.partialReadOnly = !this.editableEntry.canBeDeleted;

          // console.log("service provision edit", this.editableEntry, this.extraData);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(serviceProvision) {
      // console.log("serviceProvision", serviceProvision, serviceProvision.validations, this.deepFilterEntryWithAllowedFieldsForMutation(serviceProvision, serviceProvision.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_SERVICE_PROVISION_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(serviceProvision, serviceProvision.validations)
          }
        })
        .then(response => {
          var errors = response.data.updateServiceProvision.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
      this.$emit("entry-canceled");
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_SERVICE_PROVISION = gql `
  query ($id: ID!) {
  accountContext {
    serviceProvision(id: $id) {
      id
      code
      type
      patrimonyId
      date
      hourMeter
      odometer
      fueledLiters
      observations
      periodIds
      canBeDeleted
      cashOutflowAttributes {
        id
        code
        billDate
        totalPrice
        periodIds
        chartId
        chart {
          id
          text
        }
        supplierId
        supplier {
          id
          name
        }
        paymentsAttributes {
          id
          code
          bankAccountId
          paymentMethodId
          value
          initialDate
          installmentsIntervalId
          installmentsInterval {
            id
            description
            intervalInDays
          }
          paymentConditionId
          paymentCondition {
            id
            description
            numberOfInstallments
          }
          paymentMethod {
            id
            name
          }
          bankAccount {
            id
            name
          }
          installmentsAttributes {
            id
            value
            originalValue
            customCode
            dueDate
            code
            status
            statusKey
            statusColor
            paidAmount
            totalPaidAmount
            paymentDate
            bankAccount {
              id
              name
            }
          }
        }
        validations
      }
      activitiesAttributes {
        id
        personId
        person {
          id
          name
        }
        durationInHours
        durationInMinutes
        durationText
        startDate
        endDate
        patrimonyId
        patrimony {
          id
          description
        }
        implementId
        implement {
          id
          description
        }
      }
      exitMovementItemsAttributes {
        id
        itemId
        item {
          id
          name
          unit {
            id
            name
          }
          brand {
            id
            name
          }
        }
        packagingId
        packaging {
          id
          name
        }
        storageId
        storage {
          id
          name
        }
        quantity
        hasCropLimit
        unitQuantity
      }
      validations
    }
    allPatrimonies {
      id
      description
      workingMetricType
    }
    allSuppliers {
      id
      name
    }
    allPeople {
      id
      name
    }
    allHarvests {
      id
      name
    }
    allPeriodsEnabledForCostApportionment(periodStatuses: [1], serviceProvisionId: $id) {
      id
      name
      additionalInfo
      secondAdditionalInfo
    }
    cashOutflow {
      id
      code
      billDate
      totalPrice
      periodIds
      chartId
      chart {
        id
        text
      }
      supplierId
      supplier {
        id
        name
      }
      paymentsAttributes {
        id
        code
        bankAccountId
        paymentMethodId
        value
        initialDate
        installmentsIntervalId
        installmentsInterval {
          id
          description
          intervalInDays
        }
        paymentConditionId
        paymentCondition {
          id
          description
          numberOfInstallments
        }
        paymentMethod {
          id
          name
        }
        bankAccount {
          id
          name
        }
        installmentsAttributes {
          id
          value
          originalValue
          customCode
          dueDate
          code
          status
          statusKey
          statusColor
          paidAmount
          totalPaidAmount
          paymentDate
          bankAccount {
            id
            name
          }
        }
      }
      validations
    }
  }
  globalContext {
    allServiceProvisionTypes
    allPeriodStatuses
  }
}
`;
 
const UPDATE_SERVICE_PROVISION_MUTATION = gql `
  mutation($input: ServiceProvisionUpdateInputObject!) {
    updateServiceProvision(input: $input) {
      serviceProvision {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
